import React from 'react';

import TableLoader from '@dashboard/components/table/TableLoader';
import { Box, Paper, Stack } from '@mui/material';

import EmptyPageTutorial from './EmptyPageTutorial';
import PageHeader from './PageHeader';
import TemplateSummaryCard from './TemplateSummaryCard';
import useCurrentTemplatesQuery from './useCurrentTemplatesQuery';

export default function WaypointTemplatesList() {
  const { data } = useCurrentTemplatesQuery();
  const model = data?.WaypointTemplates;

  const renderBody = () => {
    if (model === undefined) {
      return <TableLoader />;
    }

    if (model.count === 0) {
      return <EmptyPageTutorial />;
    }

    return (
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2} py={3} px={2}>
        {model.nodes.map((n) => (
          <TemplateSummaryCard key={n.id} template={n} />
        ))}
      </Box>
    );
  };

  return (
    <Paper component={Stack}>
      <PageHeader />
      {renderBody()}
    </Paper>
  );
}
